import { parseQueryParams, parseCustomQuery } from "./parse-query-params";

export const parseUrlBotFromStartParam = (str: string): { [key: string]: string } => {
  const decodedUrl = decodeURIComponent(str);
  const parsed = parseQueryParams(decodedUrl);
  const parsedStartParam = parsed['start_param'];
  const decoderParsedStartParam = decodeURIComponent(parsedStartParam);
  const queryParamsStartParams = parseCustomQuery(decoderParsedStartParam);
  const queryParamsStartParamsWithCustom: any = {...queryParamsStartParams, openFromApp: true};

  return queryParamsStartParamsWithCustom;
}
